<template>
  <div class="currency-select-button">
    <div class="currency-select-button__icon">
      <object v-if="currencyIcon" class="flag-icon" :data="currencyIcon" width="20" height="20"/>
    </div>
    <div class="currency-select-button__label">{{ props.currency }}</div>
    <div class="currency-select-button__arrow">
      <IconForward />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

import type { Currency } from '@/types';

import IconForward from '../../../assets/images/exchange-form/forward.svg';

const props = defineProps<{
  currency: Currency
}>();

const currencyFlagName = {
  EUR: 'EU',
  AED: 'AE',
  ARS: 'AR',
  AUD: 'AU',
  AZN: 'AZ',
  BDT: 'BD',
  BRL: 'BR',
  BYN: 'BY',
  CAD: 'CA',
  CHF: 'CH',
  CRC: 'CI',
  CZK: 'CZ',
  DKK: 'DK',
  DOP: 'DO',
  DZD: 'DZ',
  EGP: 'EG',
  GEL: 'GE',
  HKD: 'HK',
  HUF: 'HU',
  INR: 'IN',
  KRW: 'KR',
  KWD: 'KW',
  MAD: 'MA',
  MYR: 'MY',
  NGN: 'NG',
  NOK: 'NO',
  PEN: 'PE',
  PHP: 'PH',
  PLN: 'PL',
  RON: 'RO',
  SAR: 'SA',
  SEK: 'SE',
  SGD: 'SG',
  THB: 'TH',
  TND: 'TN',
  TRY: 'TR',
  UAH: 'UA',
  XAF: 'CD',
  ZAR: 'ZA',
  USD: 'US',
  GBP: 'GB',
  HRK: 'HR',
  JPY: 'JP',
  CLP: 'CL',
  MXN: 'MX',
  COP: 'CO',
  ILS: 'IL',
  KES: 'KE',
  UGX: 'UG',
  XOF: 'SN',
  BHD: 'BH',
  NZD: 'NZ',
  BGN: 'BG',
} as Record<Currency, string>;

const currencyIcon = computed(() => {
  if (!currencyFlagName[props.currency]) {
    return '';
  }

  return new URL(`/node_modules/country-flag-icons/1x1/${ currencyFlagName[props.currency] }.svg`, import.meta.url).href;
});
</script>

<style lang="scss" scoped>
@import "@scss-vars";

.currency-select-button {
  display: flex;
  align-items: center;
  cursor: pointer;

  &__icon {
    margin: 0 12px;
    width: 20px;
    height: 20px;
    display: block;
    border-radius: 50%;
    background: $grey-04;
    overflow: hidden;
  }

  &__arrow {
    margin: 0 8px;

    svg {
      display: block;
      width: 24px;
    }

    [dir='rtl'] & svg {
      transform: rotate(180deg)
    }
  }
}

.flag-icon {
  width: 20px;
  height: 20px;
  display: block;
  border-radius: 50%;
}
</style>
